import refetchRequired from './refetchRequired';
import requestPlatformDataSetup from './requestPlatformData';
import SDKMessageBus from '../utility/message-bus';
import getFeatureConfig from './getFeatureConfig';
import promptForMFA from './promptForMFA';
import { TectonResponse, ISources } from '../types';
import canUser from './canUser';
import takePicture from './takePicture';
import { ITranslationSetup } from '../setup/t';
import isNavigable from './isNavigable';
import languageChanged from './languageChanged';
import requestExtensionData from './requestExtensionData';
import deprecate from 'q2-tecton-common/lib/utility/deprecate';
import { IDict } from '../types/utility';
import { BehaviorSubject } from 'rxjs';
import paramsChanged from './paramsChanged';
import cacheCleared from './cacheCleared';

export default function setupSources(
    messageBus: SDKMessageBus,
    moduleInstanceId: string,
    sourceInfo: ITranslationSetup,
    teardowns: (() => void)[],
    platformCapabilities: Set<string>,
    params$: BehaviorSubject<IDict<string>>
): ISources {
    const requestPlatformData = requestPlatformDataSetup(messageBus, platformCapabilities);
    const fetchPlatformData =
        requestPlatformData &&
        function(route: string): Promise<TectonResponse> {
            return requestPlatformData({ route, method: 'GET' });
        };

    return {
        cacheCleared: cacheCleared(messageBus, teardowns, platformCapabilities),
        refetchRequired: refetchRequired(messageBus, teardowns, platformCapabilities),
        getFeatureConfig: getFeatureConfig(messageBus, moduleInstanceId, platformCapabilities),
        languageChanged: languageChanged(sourceInfo.$locale, platformCapabilities, teardowns),
        canUser: canUser(messageBus, platformCapabilities),
        requestExtensionData: requestExtensionData(
            messageBus,
            platformCapabilities,
            moduleInstanceId
        ),
        requestPlatformData,
        fetchPlatformData,
        t(key: string, substitutions?: string[]): string {
            deprecate('`t()` is deprecated in favor of `loc().`', {
                until: '1.0.0',
                package: 'q2-tecton-sdk'
            });
            return sourceInfo.tFn(key, substitutions);
        },
        loc: sourceInfo.tFn,
        takePicture: takePicture(messageBus, platformCapabilities),
        isNavigable: isNavigable(messageBus, platformCapabilities),
        paramsChanged: paramsChanged(params$, teardowns),
        promptForMFA: promptForMFA(messageBus, moduleInstanceId, platformCapabilities)
    };
}
